import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { ResultsTypes } from 'store/modules/market_store/types';
import moment from 'moment';
import colors from 'styles/colors';

interface ResultMarketModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  resultData: ResultsTypes;
}

const ResultMarketModal = (props: ResultMarketModalProps) => {
  const { showModal, setShowModal, resultData } = props;

  return (
    <Modal size="lg" show={showModal}>
      <div className="row">
        <div className="col-md-12">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: colors.$dark_light }}>
              <h5 className="modal-title text-white font-weight-bold">Resultado</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="px-3">
              <div className="row mt-4">
                <div className="col-md-12">
                  <span className="font-weight-bold">Objeto</span>
                  <p>{resultData?.licitacao?.objeto}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row">
                <div className="col-md-4">
                  <span className="font-weight-bold">Data</span>
                  <p>{moment.parseZone(resultData?.licitacao?.data_validade).format('L')}</p>
                </div>
                <div className="col-md-4">
                  <span className="font-weight-bold">Nº ConLicitação</span>
                  <p>{resultData?.licitacao?.id}</p>
                </div>
                <div className="col-md-4">
                  <span className="font-weight-bold">Situação</span>
                  <p>{resultData?.licitacao?.tipo_agrupamento_descricao}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row">
                <div className="col-md-4">
                  <span className="font-weight-bold">Edital</span>
                  <p>{resultData?.licitacao?.edital}</p>
                </div>
                <div className="col-md-8">
                  <span className="font-weight-bold">Processo</span>
                  <p>{resultData?.licitacao?.processo}</p>
                </div>
              </div>
            </div>
            <hr />
            <div className="px-3">
              <div className="row">
                <div className="col-md-8">
                  <span className="font-weight-bold">Órgão</span>
                  <p>{resultData?.licitacao?.orgao?.nome}</p>
                </div>
                <div className="col-md-4">
                  <span className="font-weight-bold">UASG</span>
                  <p>{resultData?.licitacao?.orgao?.uasg}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row">
                <div className="col-md-6">
                  <span className="font-weight-bold">Cidade </span>
                  <p>
                    {resultData?.licitacao?.orgao?.cidade}/{resultData?.licitacao?.orgao?.estado}
                  </p>
                </div>
                <div className="col-md-6">
                  <span className="font-weight-bold">Endereço </span>
                  <p>{resultData?.licitacao?.orgao?.endereco}</p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-md-12">
              <div className="card shadow">
                <div className="table-responsive" style={{ maxHeight: '360px' }}>
                  <table className="table table-hover w-auto mb-0 table-bordered">
                    <thead style={{ backgroundColor: '#EBECEF' }}>
                      <tr>
                        <th scope="col">Item</th>
                        <th scope="col">Vencedor</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Un. Fornecimento</th>
                        <th scope="col">Qnt.</th>
                        <th scope="col">Valor unitário</th>
                        <th scope="col">Valor total</th>
                      </tr>
                    </thead>
                    <tbody className="tbody-modal">
                      {resultData?.licitacao?.resultados?.map((result) => (
                        <tr key={result.id}>
                          <td>{result.item_numero}</td>
                          <td>
                            <a
                              href={
                                result.cnpj.toString().length === 13
                                  ? `/concorrente/0${result.cnpj}`
                                  : `/concorrente/${result.cnpj}`
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              {result.fornecedor}
                            </a>
                          </td>
                          <td>{result.item_descricao}</td>
                          <td>{result.item_unidade}</td>
                          <td>{result.item_quantidade}</td>
                          <td>
                            {result.item_valor_unitario
                              ? result.item_valor_unitario.toLocaleString('pt-br', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })
                              : ' - '}
                          </td>
                          <td>
                            {result.item_valor_total
                              ? result.item_valor_total.toLocaleString('pt-br', {
                                  style: 'currency',
                                  currency: 'BRL',
                                })
                              : ' - '}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setShowModal(false)}
              >
                fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ResultMarketModal;
